import { render, staticRenderFns } from "./StatSaillies.vue?vue&type=template&id=5f7d8f88&"
import script from "./StatSaillies.vue?vue&type=script&lang=js&"
export * from "./StatSaillies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports